<template>
    <div class="purchase-course vod">

        <div class="row justify-content-center">
            <div class="col-md-12">
                <template v-if="exam.isReadyForSale">
                    <purchase-exam-component :vod-course="vodCourse" :exam="exam" :is-spotify-referral="isSpotifyReferral"></purchase-exam-component>
                </template>
                <template v-else>
                    <preregister-exam-component :exam="exam"></preregister-exam-component>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        vodCourse: {
            type: Object,
            required: true,
            default: null,
        },
        exam: {
            type: Object,
            required: true,
        },
        isSpotifyReferral: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
        }
    },

    mounted() {
    },
}
</script>
